import React from 'react';
import { Link } from 'react-router-dom';
import { Tag, Typography } from 'antd';
import { PageHeader } from '@ant-design/pro-layout';
import { getCargoTypeLabel } from 'shared/utils/cargos/cargo-type-labels.ts';
import { CargoType } from 'types/cargo';
import { CargoCmrReceivedUpdate } from 'components/cargos/cargo-cmr-received-update';
import { CargoEdit } from 'components/cargos/cargo-edit';
import { CargoExtraActions } from 'components/cargos/cargo-extra-actions';
import { CargoItemCreate } from 'components/cargos/cargo-item-create';
import { CargoItemStatuses } from 'components/cargos/cargo-item-status';
import { CargoStickerGenerator } from 'components/cargos/cargo-sticker-generator';
import { ImportantCargoDocumentFlags } from 'components/documents/important-cargo-document-flags';
import styles from './cargo-page-header.module.scss';
import type { ICargoPageHeaderProps } from './types';

export const CargoPageHeader: React.FC<ICargoPageHeaderProps> = (props) => {
  const { cargo } = props;
  const showCargoItemCreate = cargo.type !== CargoType.CONTAINER;

  return (
    <PageHeader
      title={cargo.compositeId}
      extra={[
        ...(showCargoItemCreate
          ? [<CargoItemCreate key='cargo-item-create' cargoId={cargo.id} cargoType={cargo.type} />]
          : []),
        <CargoStickerGenerator key='cargo-sticker-generator' cargoId={cargo.id} />,
        <CargoCmrReceivedUpdate key='cargo-cmr-received-update' cargoId={cargo.id} cmrReceived={cargo.cmrReceived} />,
        <CargoEdit key='cargo-edit' cargo={cargo} />,
        <CargoExtraActions key='cargo-extra-actions' cargoId={cargo.id} />,
      ]}
      tags={[
        <Tag key='cargo-item-type'>{getCargoTypeLabel(cargo.type)}</Tag>,
        <CargoItemStatuses key='cargo-item-status' statuses={cargo.statuses} assetIsReturned={cargo.assetIsReturned} />,
        <ImportantCargoDocumentFlags documents={cargo.documents} />,
      ]}
      onBack={() => history.back()}>
      <div className={styles.container}>
        <div>
          <Link to={`/orders/${cargo.order.id}`} className={styles.orderIdLink}>
            {cargo.order.compositeId}
          </Link>
          <Typography.Text className={styles.clientOrderNumber}>{cargo.order.clientOrderNumber}</Typography.Text>
        </div>
      </div>
    </PageHeader>
  );
};
